'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('../css/TabControl.css');

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _utilsLib = require('utils-lib');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TabControl = function (_Component) {
  _inherits(TabControl, _Component);

  function TabControl(props) {
    _classCallCheck(this, TabControl);

    var _this = _possibleConstructorReturn(this, (TabControl.__proto__ || Object.getPrototypeOf(TabControl)).call(this, props));

    _this.state = {};
    _this.state.Content = _this.props.Content;
    return _this;
  }

  _createClass(TabControl, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      //add click event to tabs
      var refsTablinks = [];
      if (this.state.Content) {
        var _loop = function _loop(i) {
          document.getElementById('tab' + _this2.state.Content[i].Title + _this2.props.Id).addEventListener("click", function (e) {
            _this2.openTab(e, _this2.state.Content[i].Title);
            (0, _jquery2.default)('#topnav' + _this2.props.Id).removeClass().addClass('topnav');
          });
          refsTablinks.push(_this2.refs["tab" + _this2.state.Content[i].Title + _this2.props.Id]);
        };

        for (var i = 0; i < this.state.Content.length; i++) {
          _loop(i);
        }
        //default open first tab
        document.getElementById('tab' + this.state.Content[0].Title + this.props.Id).click();
      }

      this.setState({ RefsTablinks: refsTablinks }, function () {
        var widthContainer = document.getElementById("TabControl" + _this2.props.Id).offsetWidth;
        var elem = document.getElementsByClassName('tablinks');
        var widthButtons = 0;
        for (var i = 0; i < elem.length; i++) {
          if (_utilsLib.CheckValues.includes(elem[i].id, _this2.props.Id)[0] === true) {
            widthButtons += elem[i].offsetWidth;
          }
        }
        if (widthButtons > widthContainer) {
          for (var _i = 0; _i < elem.length; _i++) {
            if (_utilsLib.CheckValues.includes(elem[_i].id, _this2.props.Id)[0] === true) {
              elem[_i].style.display = "none";
            }
          }
          document.getElementById("hamburgerMenu" + _this2.props.Id).style.display = "block";
        }
      });

      this.LogoClick();

      this.FontSizeClick();
    }
  }, {
    key: 'openTab',
    value: function openTab(evt, tabName) {
      // Declare all variables
      var i, tabcontent, tablinks;

      // Get all elements with class="tabcontent" and hide them
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        if (_utilsLib.CheckValues.includes(tabcontent[i].id, this.props.Id)[0] === true) {
          tabcontent[i].style.display = "none";
        }
      }

      // Get all elements with class="tablinks" and remove the class "active"
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        if (_utilsLib.CheckValues.includes(tablinks[i].id, this.props.Id)[0] === true) {
          tablinks[i].className = tablinks[i].className.replace(" active", "");
        }
      }

      // Show the current tab, and add an "active" class to the button that opened the tab
      document.getElementById(tabName + this.props.Id).style.display = "block";
      evt.currentTarget.className += " active";

      _reactDom2.default.render(_react2.default.createElement(
        'div',
        null,
        tabName
      ), document.getElementById('titleMenu' + this.props.Id));

      this.LogoClick();

      this.FontSizeClick();
    }
  }, {
    key: 'myFunction',
    value: function myFunction() {
      var x = document.getElementById("topnav" + this.props.Id);
      if (x.className === "topnav") {
        x.className += " responsive";
      } else {
        x.className = "topnav";
      }
    }
  }, {
    key: 'LogoClick',
    value: function LogoClick() {

      var kontrastNumber = localStorage.getItem('Kontrast');

      if (kontrastNumber == "true") {

        (0, _jquery2.default)('.tablinks').attr('style', 'background-color: white !important; color: black !important;');
        (0, _jquery2.default)('.active').attr('style', 'background-color: #00375b !important; color: white !important;');
      } else if (kontrastNumber == "false") {
        (0, _jquery2.default)('.tablinks').attr('style', 'background-color: white !important; color: black !important;');
        (0, _jquery2.default)('.active').attr('style', 'background-color: #0078c8 !important; color: white !important;');
      }
    }
  }, {
    key: 'FontSizeClick',
    value: function FontSizeClick() {
      var schriftgröße = localStorage.getItem('Schriftgröße');
      var role = localStorage.getItem("vas_role");

      //Schriftgröße bei Klick in 2er Schritten erhöhen

      if (schriftgröße != null) {

        switch (schriftgröße) {
          case "0":

            if (role === '3') {
              (0, _jquery2.default)('.tablinks').removeClass('Schriftgröße_17').addClass('Schriftgröße_18');
              (0, _jquery2.default)('.active').removeClass('Schriftgröße_17').addClass('Schriftgröße_18');
            }
            break;
          case "1":

            if (role === '3') {
              (0, _jquery2.default)('.tablinks').removeClass('Schriftgröße_18').addClass('Schriftgröße_13');
              (0, _jquery2.default)('.active').removeClass('Schriftgröße_18').addClass('Schriftgröße_13');
            }

            break;
          case "2":

            if (role === '3') {
              (0, _jquery2.default)('.tablinks').removeClass('Schriftgröße_13').addClass('Schriftgröße_14');
              (0, _jquery2.default)('.active').removeClass('Schriftgröße_13').addClass('Schriftgröße_14');
            }

            break;
          case "3":
            if (role === '3') {
              (0, _jquery2.default)('.tablinks').removeClass('Schriftgröße_14').addClass('Schriftgröße_15');
              (0, _jquery2.default)('.active').removeClass('Schriftgröße_14').addClass('Schriftgröße_15');
            }
            break;
          case "4":

            if (role === '3') {
              (0, _jquery2.default)('.tablinks').removeClass('Schriftgröße_15').addClass('Schriftgröße_16');
              (0, _jquery2.default)('.active').removeClass('Schriftgröße_15').addClass('Schriftgröße_16');
            }
            break;
          case "5":

            if (role === '3') {
              (0, _jquery2.default)('.tablinks').removeClass('Schriftgröße_16').addClass('Schriftgröße_17');
              (0, _jquery2.default)('.active').removeClass('Schriftgröße_16').addClass('Schriftgröße_17');
            }
            break;
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var buttons = [];
      if (this.state.Content) {
        for (var i = 0; i < this.state.Content.length; i++) {
          var button = _react2.default.createElement(
            'button',
            {
              id: "tab" + this.state.Content[i].Title + this.props.Id,
              className: 'tablinks'
            },
            this.state.Content[i].Title
          );
          buttons.push(button);
        }
      }

      var content = [];
      if (this.state.Content) {
        for (var _i2 = 0; _i2 < this.state.Content.length; _i2++) {
          content.push(_react2.default.createElement(
            'div',
            {
              id: this.state.Content[_i2].Title + this.props.Id,
              className: 'tabcontent' },
            this.state.Content[_i2].Content
          ));
        }
      }

      return _react2.default.createElement(
        'div',
        {
          className: "TabControl",
          id: "TabControl" + this.props.Id },
        _react2.default.createElement(
          'div',
          {
            className: 'topnav',
            id: "topnav" + this.props.Id },
          buttons,
          _react2.default.createElement(
            'div',
            {
              id: "hamburgerMenu" + this.props.Id,
              className: "hamburgerMenu" },
            _react2.default.createElement(
              'table',
              null,
              _react2.default.createElement(
                'tbody',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(_Icon2.default, {
                      Color: "black",
                      Name: "Menu",
                      Size: 36,
                      OnClick: function OnClick() {
                        _this3.myFunction();
                      } })
                  ),
                  _react2.default.createElement('td', { id: "titleMenu" + this.props.Id })
                )
              )
            )
          )
        ),
        content
      );
    }
  }]);

  return TabControl;
}(_react.Component);

exports.default = TabControl;